import {IPropertyConverter} from '@mintdata/mint-kit/api/properties/PropertyConverter';
import {ValidationMessages} from '@mintdata/mint-kit/api/properties/ValidationMessages';
import {ValidationResult} from '@mintdata/mint-kit/api/properties/ValidationResult';
import {Empty} from '@mintdata/mint-kit/api/types/Value';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';

export class AIntegerConverter implements IPropertyConverter<AInteger>
{
    public validate(aIntegerString:string, isRequired:boolean = true):ValidationResult
    {
        aIntegerString = (aIntegerString || '').toLowerCase().trim();

        if( aIntegerString.length === 0 )
        {
            if( isRequired )
                return ValidationResult.error(ValidationMessages.nonEmpty(AInteger));
            else
                return ValidationResult.valid();
        }

        const numberValue:number = parseInt(aIntegerString, 10);
        const floatValue:number = parseFloat(aIntegerString);

        if( !isNaN(numberValue) && !isNaN(floatValue) && numberValue === floatValue )
            return ValidationResult.valid();
        else
            return ValidationResult.error(ValidationMessages.unknownValue(aIntegerString, AInteger));
    }

    public validateValue(aInteger:AInteger, isRequired:boolean = true):ValidationResult
    {
        return this.validate(String(aInteger && aInteger.value), isRequired);
    }

    public valueToString(aInteger:AInteger, isFocused:boolean = false):string
    {
        if( aInteger === Empty )
            return '';

        return aInteger && aInteger.value != null ? String(aInteger.value) : '';
    }

    public stringToValue(aIntegerString:string, isRequired:boolean = true):AInteger | AError
    {
        aIntegerString = (aIntegerString || '').toLowerCase().trim();

        if( !isRequired && aIntegerString.length === 0 )
            return Empty;

        const numberValue:number = parseInt(aIntegerString, 10);

        if( !isNaN(numberValue) )
            return AInteger.fromNumber(numberValue);

        return AError.fromString('Invalid AInteger value: ' + aIntegerString);
    }
}
